const API_PREFIX = {
  AUTH: '/api-owner',
  PRODUCT: '/api-lip/v1',
  RECEIVE: '/api-inbound/v1/3pl',
  RECEIVE_2: '/api-inbound/v1/kls',
  STOCK: '/api-inventory/v1',
  ORDER: '/api-oms',
  CLAIM: '/api-oms',
  SETTLEMENT: '/api-inventory-agg/v1',
  VENDER: '/api-owner',
  DELIVERY_AGENCY: '/api-delivery-agency',
} as const;

export const API_ENDPOINT = {
  PRODUCT: {
    /** 상품 리스트 조회 */
    GET_SKUS: `${API_PREFIX.PRODUCT}/third-parties/skus`,
    /** 공통 코드 조회 */
    GET_PRODUCT_CODES_MENU: `${API_PREFIX.PRODUCT}/codes/menu`,
    /** 상품 삭제 */
    DELETE_SKUS: `${API_PREFIX.PRODUCT}/third-parties/skus/disable`,
    /** 상품 단건 상세 조회 */
    GET_SKUS_SKU_CODE: `${API_PREFIX.PRODUCT}/third-parties/skus`,
    /** 운영상품 상세 조회 */
    GET_ACTIVE_SKUS_SKU_CODE: `${API_PREFIX.PRODUCT}/third-parties/active-skus`,
  },

  RECEIVE: {
    /** 입고관리 필터 조회 */
    GET_FILTER_ALL: `${API_PREFIX.RECEIVE}/filter/all`,
    /** 입고요청 복사 */
    GET_REQUEST_COPY: `${API_PREFIX.RECEIVE}/receiving`,
    /**
     * 검수확인용 거래명세서 다운로드
     * @endpoint /receiving/{ownerCode}/specifications?ids={ids}
     */
    GET_RECEIVING_SPECIFICATIONS: `${API_PREFIX.RECEIVE}/receiving`,
    /**
     * 입고요청 목록 엑셀 다운로드
     * @endpoint /receiving/{ownerCode}/requests/requested/download
     */
    GET_REQUESTS_REQUESTED_DOWNLOAD: `${API_PREFIX.RECEIVE}/receiving`,
    /**
     * 입고상품추가 모달 > 상품 조회
     * @endpoint /receiving/{ownerCode}/request/goods
     */
    GET_REQUEST_GOODS: `${API_PREFIX.RECEIVE}/receiving`,
    /**
     * 입고 현황 목록 조회
     * @endpoint /receiving/{ownerCode}/progress
     */
    GET_RECEIVING_PROGRESS: `${API_PREFIX.RECEIVE}/receiving`,
    /**
     * 입고 현황 상세 조회
     * @endpoint /receiving/{ownerCode}/progress/{itemId}
     */
    GET_RECEIVING_PROGRESS_ITEM_ID: `${API_PREFIX.RECEIVE}/receiving`,
    /**
     * 입고 서명확인용 거래명세서 다운로드
     * @endpoint /receiving/{ownerCode}/sign-specification
     */
    GET_RECEIVING_SIGN_SPECIFICATION: `${API_PREFIX.RECEIVE}/receiving`,
    /**
     * 입고 현황 목록 엑셀 다운로드
     * @endpoint /receiving/{ownerCode}/progress/download
     */
    GET_RECEIVING_PROGRESS_DOWNLOAD: `${API_PREFIX.RECEIVE}/receiving`,
    /**
     * 입고 리포트 관리 목록 조회
     * @endpoint /receiving/{ownerCode}/report/histories
     */
    GET_REPORT_HISTORIES: `${API_PREFIX.RECEIVE}/receiving`,
    /**
     * 입고 리포트 발행 목록 엑셀 다운로드
     * @endpoint /receiving/{ownerCode}/report/histories/download
     */
    GET_REPORT_HISTORIES_DOWNLOAD: `${API_PREFIX.RECEIVE}/receiving`,
    /**
     * 입고 리포트 상세 조회
     * @endpoint /receiving/{ownerCode}/report/histories/{reportId}
     */
    GET_REPORT_HISTORIES_REPORT_DETAIL: `${API_PREFIX.RECEIVE}/receiving`,
    /**
     * 3PL 입고 현황 목록 조회
     * @endpoint /receiving/{ownerCode}/inbound-request/progress
     */
    GET_INBOUND_REQUEST_PROGRESS: `${API_PREFIX.RECEIVE}/receiving`,
    /**
     * 3PL 입고 현황 상세 조회
     * @endpoint /receiving/{ownerCode}/inbound-request/progress/{requestId}
     */
    GET_INBOUND_REQUEST_PROGRESS_REQUEST_ID: `${API_PREFIX.RECEIVE}/receiving`,
    /**
     * 3PL 입고 현황 목록 엑셀 다운로드
     * @endpoint /receiving/{ownerCode}/inbound-request/progress/download
     */
    GET_INBOUND_REQUEST_PROGRESS_DOWNLOAD: `${API_PREFIX.RECEIVE}/receiving`,
  },

  RECEIVE_2: {
    /**
     * 입하 라벨 출력 - 상품 조회
     * @endpoint /receiving-label/{ownerCode}/items
     */
    GET_RECEIVING_LABEL_ITEMS: `${API_PREFIX.RECEIVE_2}/receiving-label`,
    /**
     * 입하 라벨 출력 - 라벨 조회
     * @endpoint /receiving-label/{ownerCode}/labels
     */
    PUT_RECEIVING_LABEL_LABELS: `${API_PREFIX.RECEIVE_2}/receiving-label`,
  },

  ORDER: {
    /** 공통 코드 조회 */
    GET_CODES: `${API_PREFIX.ORDER}/codes`,
    /** 출고주문 리스트 조회 */
    GET_ORDERS: `${API_PREFIX.ORDER}/orders`,
    /** 출고주문 상세 조회 */
    GET_ORDER_OUTBOUND_ORDER_CODE: `${API_PREFIX.ORDER}/order`,
  },

  CLAIM: {
    /** 반품 리스트 조회 */
    GET_RETURN_ORDERS: `${API_PREFIX.CLAIM}/return-orders`,
    /** 반품 취소 */
    DELETE_RETURN_ORDERS: `${API_PREFIX.CLAIM}/return-orders`,
    /** 반품 상세 조회 */
    GET_RETURN_ORDERS_RETURN_RECEIPT_ID: `${API_PREFIX.CLAIM}/return-orders`,
    /** 반품 신청 여부 조회 */
    GET_RETURN_ORDERS_EXISTENCE: `${API_PREFIX.CLAIM}/return-orders/existence`,
    /** 반품 신청 등록 */
    POST_RETURN_ORDERS: `${API_PREFIX.CLAIM}/return-orders`,
    /** 교환 리스트 조회 */
    GET_EXCHANGE_ORDERS: `${API_PREFIX.CLAIM}/exchange-orders`,
    /** 교환 신청 여부 조회 */
    GET_EXCHANGE_ORDERS_EXISTENCE: `${API_PREFIX.CLAIM}/exchange-orders/existence`,
    /** 교환 신청 등록 */
    POST_EXCHANGE_ORDERS: `${API_PREFIX.CLAIM}/exchange-orders`,
    /** 교환 취소 */
    DELETE_EXCHANGE_ORDERS: `${API_PREFIX.CLAIM}/exchange-orders`,
    /** 교환 신청 상세 조회 */
    GET_EXCHANGE_ORDERS_EXCHANGE_RECEIPT_ID: `${API_PREFIX.CLAIM}/exchange-orders`,
    /** 교환 재배송 처리 */
    POST_EXCHANGE_ORDERS_RESEND: `${API_PREFIX.CLAIM}/exchange-orders`,
  },
  DELIVERY_AGENCY: {
    /**
     * [배송 현황]
     */
    /** 실시간 배송 현황 조회 */
    GET_DASHBOARD_DELIVERY_STATUS: `${API_PREFIX.DELIVERY_AGENCY}/dashboard/delivery-status`,
    /** 배송 추이 조회 */
    GET_DASHBOARD_DELIVERY_TREND: `${API_PREFIX.DELIVERY_AGENCY}/dashboard/delivery-trend`,
    /**
     * [배송주문관리]
     */
    /** 배송 주문 검색 코드 조회 */
    GET_ORDERS_CODES: `${API_PREFIX.DELIVERY_AGENCY}/orders/search-conditions`,
    /** 배송 주문 리스트 조회 */
    GET_ORDERS: `${API_PREFIX.DELIVERY_AGENCY}/orders`,
    /** 배송 주문 상세 조회 */
    GET_ORDER_DETAIL: `${API_PREFIX.DELIVERY_AGENCY}/orders`,
    /** 주문 목록 전체 엑셀 다운로드 */
    GET_ORDERS_EXCEL_DOWNLOAD: `${API_PREFIX.DELIVERY_AGENCY}/orders/download`,
    /** 주문 엑셀 양식 다운로드 */
    GET_TEMPLATES_DOWNLOAD_URL: `${API_PREFIX.DELIVERY_AGENCY}/templates/download-url`,
    /** 주문 엑셀 일괄 등록 */
    POST_ORDERS_UPLOAD: `${API_PREFIX.DELIVERY_AGENCY}/orders/upload`,
    /** 주문 취소 */
    POST_ORDERS_CANCEL: `${API_PREFIX.DELIVERY_AGENCY}/orders/cancel`,
    /**
     * [운송장관리]
     */
    /** 운송장 관리 검색 코드 조회 */
    GET_SHIPPING_LABELS_CODES: `${API_PREFIX.DELIVERY_AGENCY}/shipping-labels/search-conditions`,
    /** 운송장 관리 리스트 조회 */
    GET_SHIPPING_LABELS: `${API_PREFIX.DELIVERY_AGENCY}/shipping-labels`,
    /** 운송장 상세 조회 */
    GET_SHIPPING_LABEL_DETAIL: `${API_PREFIX.DELIVERY_AGENCY}/shipping-labels`,
    /** 운송장 출력 */
    POST_SHIPPING_LABELS_PRINT: `${API_PREFIX.DELIVERY_AGENCY}/shipping-labels/print`,
    /** 운송장 취소 */
    POST_SHIPPING_LABELS_CANCEL: `${API_PREFIX.DELIVERY_AGENCY}/shipping-labels/cancel`,
    /** 운송장 목록 전체 엑셀 다운로드 */
    POST_SHIPPING_LABELS_EXCEL_DOWNLOAD: `${API_PREFIX.DELIVERY_AGENCY}/shipping-labels/download`,
    /** 출고 단위 조회 */
    GET_OUTBOUNDS: `${API_PREFIX.DELIVERY_AGENCY}/outbounds`,
    /** 운송장 생성 */
    POST_SHIPPING_LABELS_CREATE: `${API_PREFIX.DELIVERY_AGENCY}/shipping-labels`,
    /**
     * [스마트검색]
     */
    /** 자주 묻는 질문 목록 조회 */
    GET_SMART_SEARCH_FREQUENT_QUESTIONS: `${API_PREFIX.DELIVERY_AGENCY}/smart-search/frequent-questions`,
    /**
     * 스마트 검색
     * @endpoint /smart-search?query={query}
     */
    GET_SMART_SEARCH: `${API_PREFIX.DELIVERY_AGENCY}/smart-search`,
    /**
     * 스마트 검색 피드백 전송
     * @endpoint /smart-search/{queryId}/feedback
     */
    POST_SMART_SEARCH_FEEDBACK: `${API_PREFIX.DELIVERY_AGENCY}/smart-search`,
    /** 배송운영 정보 조회 */
    GET_SHIPPERS_DELIVERY_OPERATIONS: `${API_PREFIX.DELIVERY_AGENCY}/shippers/delivery-operations`,
    /**  화주사 배송 권역 조회 */
    GET_DELIVERY_TYPE: `${API_PREFIX.DELIVERY_AGENCY}/shippers`,
    /**
     * [합포 단위 관리]
     */
    /** 출고 단위 검색 코드 조회 */
    GET_OUTBOUNDS_SEARCH_CONDITIONS: `${API_PREFIX.DELIVERY_AGENCY}/outbounds/search-conditions`,
    /** 출고 단위 리스트 조회 */
    GET_OUTBOUNDS_LIST: `${API_PREFIX.DELIVERY_AGENCY}/outbounds/list`,
    /** 출고 단위 합포장 */
    POST_OUTBOUNDS_GROUP: `${API_PREFIX.DELIVERY_AGENCY}/outbounds/group`,
    /** 출고 단위 합포장 취소 */
    POST_OUTBOUNDS_UNGROUP: `${API_PREFIX.DELIVERY_AGENCY}/outbounds/ungroup`,
    /**
     * [배송 결과 리포트]
     */
    /** 배송 결과 리포트 검색 조건 코드 조회 */
    GET_DELIVERY_RESULT_REPORTS_CODES: `${API_PREFIX.DELIVERY_AGENCY}/delivery-result-reports/search-conditions`,
    /** 배송 결과 리포트 목록 조회 */
    GET_DELIVERY_RESULT_REPORTS: `${API_PREFIX.DELIVERY_AGENCY}/delivery-result-reports`,
    /** 배송 결과 리포트 상세 조회 */
    GET_DELIVERY_RESULT_REPORT_DETAIL: `${API_PREFIX.DELIVERY_AGENCY}/delivery-result-reports`,
    /** 배송 결과 리포트 목록 전체 엑셀 다운로드 */
    POST_DELIVERY_RESULT_REPORTS_DOWNLOAD: `${API_PREFIX.DELIVERY_AGENCY}/delivery-result-reports/download`,
  },

  STOCK: {
    /** 공통 코드 조회 */
    GET_CODES: `${API_PREFIX.STOCK}/code/items`,
    /** 반출 방식 코드 조회 */
    GET_VENDOR_RELEASE_METHOD_CODE: `${API_PREFIX.STOCK}/inventory/vendor-release/code/method`,
    /** 반출 리스트 조회 */
    POST_VENDOR_RELEASE_SEARCH: `${API_PREFIX.STOCK}/inventory/vendor-release/search`,
    /** 반출 등록 */
    POST_VENDOR_RELEASE: `${API_PREFIX.STOCK}/inventory/vendor-release`,
    /** 반출 요청 재고 조회 */
    POST_VENDOR_RELEASE_INVENTORY: `${API_PREFIX.STOCK}/inventory/vendor-release/inventory`,
    /** 반출 요청 반출지 정보 조회 */
    GET_VENDOR_RELEASE_RECENT_INFO: `${API_PREFIX.STOCK}/inventory/vendor-release/recent-info`,
    /** 반출 상세 조회 .../{id} */
    GET_VENDOR_RELEASE_ID: `${API_PREFIX.STOCK}/inventory/vendor-release`,
    /** 반출 상태 변경 */
    POST_VENDOR_RELEASE_STATUS: `${API_PREFIX.STOCK}/inventory/vendor-release/status`,
    /** 반출 상세 엑셀 다운로드 .../{id}/excel-download */
    GET_VENDOR_RELEASE_EXCEL_DOWNLOAD_ID: `${API_PREFIX.STOCK}/inventory/vendor-release`,
  },

  VENDER: {
    /** 화주사 정보 수정 */
    PATCH_OWNER: `${API_PREFIX.VENDER}/owner`,
  },
};
